import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "incident"
const IncidentIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M13.125 16.875H10.875V14.625H13.125zM13.125 13.125H10.875V7.125H13.125z" />
          <path
            fillRule="evenodd"
            d="M10.909 2.657C11.5 2.03 12.499 2.03 13.09 2.657L14.539 4.191 16.609 3.801C17.457 3.64 18.264 4.227 18.374 5.083L18.644 7.173 20.547 8.075C21.328 8.445 21.637 9.394 21.223 10.151L20.21 12 21.223 13.85C21.637 14.607 21.328 15.556 20.548 15.925L18.643 16.827 18.374 18.917 18.346 19.075C18.176 19.792 17.503 20.28 16.767 20.222L16.61 20.2 14.538 19.81 13.091 21.342 12.978 21.453C12.417 21.933 11.583 21.933 11.025 21.453L10.909 21.343 9.463 19.809 7.392 20.2C6.597 20.35 5.837 19.844 5.654 19.076L5.626 18.917 5.358 16.827 3.452 15.925C2.721 15.58 2.404 14.723 2.71 13.993L2.778 13.85 3.79 12 2.778 10.15C2.364 9.395 2.672 8.445 3.452 8.076L5.358 7.173 5.626 5.083C5.736 4.227 6.544 3.641 7.392 3.801L9.463 4.19zM9.99 5.817 7.114 5.274 6.741 8.18 4.094 9.431 5.499 12 4.094 14.57 6.74 15.82 7.114 18.726 9.991 18.183 12.001 20.313 14.008 18.184 16.887 18.726 17.26 15.821 19.907 14.57 18.502 12 19.907 9.43 17.26 8.18 16.887 5.273 14.009 5.817 12 3.687z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default IncidentIcon
